/**
 * 全局消息提示
 *
 * antd 5 的静态 message.xxx 拿不到 ConfigProvider 的主题上下文（控制台会告警），
 * 因此这里保存一份由 <FeedbackBridge />（App.useApp()）注入的实例，
 * 非组件代码（如 axios 拦截器）通过本模块弹提示。
 * 在 React 首次渲染之前调用会退化为 console，不会丢失错误信息。
 */

import type { MessageInstance } from 'antd/es/message/interface';
import type { NotificationInstance } from 'antd/es/notification/interface';

let messageApi: MessageInstance | null = null;
let notificationApi: NotificationInstance | null = null;

export function registerFeedback(apis: {
  message: MessageInstance;
  notification: NotificationInstance;
}): void {
  messageApi = apis.message;
  notificationApi = apis.notification;
}

export const feedback = {
  success(content: string): void {
    if (messageApi) messageApi.success(content);
    else console.info('[success]', content);
  },
  info(content: string): void {
    if (messageApi) messageApi.info(content);
    else console.info('[info]', content);
  },
  warning(content: string): void {
    if (messageApi) messageApi.warning(content);
    else console.warn('[warn]', content);
  },
  error(content: string): void {
    if (messageApi) messageApi.error(content);
    else console.error('[error]', content);
  },
  notify(title: string, description: string, type: 'info' | 'success' | 'warning' | 'error' = 'info'): void {
    if (notificationApi) {
      notificationApi[type]({ message: title, description, placement: 'topRight' });
    } else {
      console.info(`[${type}] ${title} — ${description}`);
    }
  },
};
